






import { fixedHtmlData } from "@/services/posts/postTypes/fixedhtml";
import { Component, Prop, Vue } from "vue-property-decorator";
import QrcodeVue from "qrcode.vue";
@Component({
    components: {
        QrcodeVue
    }
})
export default class QrcodeComponent extends Vue {
    @Prop() vsid!: string;
    @Prop() data!: fixedHtmlData[];

    get properties(): fixedHtmlData {
        return this.data.filter((x: fixedHtmlData) => x.id === this.vsid)[0];
    }

    // Quitezone for qrcode, one quitezone will be 10px and height and width to match size.
    get qrcodeStyling() {
        return `
            padding: ${this.properties.qrCodeQuiteZone}0px;
            height: ${this.properties.qrCodeSize}px;
            width: ${this.properties.qrCodeSize}px;
        `;
    }
}
